import { render, staticRenderFns } from "./IfBetTab.vue?vue&type=template&id=a565ad34&"
import script from "./IfBetTab.vue?vue&type=script&lang=js&"
export * from "./IfBetTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports